import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_MapWindow = _resolveComponent("MapWindow")!
  const _component_AppMainLayout = _resolveComponent("AppMainLayout")!
  const _component_FooterBar = _resolveComponent("FooterBar")!
  const _component_EventsListModal = _resolveComponent("EventsListModal")!
  const _component_InfoModal = _resolveComponent("InfoModal")!
  const _component_StartModal = _resolveComponent("StartModal")!
  const _component_CookiesButton = _resolveComponent("CookiesButton")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, {
    color: "primary",
    class: _normalizeClass(["its-map-app", [
    {'contrast-active': !!_ctx.getContrastActive}, 
    { 'mobile-app': _ctx.mobileView()},
    _ctx.getFontSizeClass
    ]])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_TopBar),
      _createVNode(_component_AppMainLayout, null, {
        "left-sidebar": _withCtx(() => _cache[0] || (_cache[0] = [])),
        "right-sidebar": _withCtx(() => _cache[1] || (_cache[1] = [])),
        main: _withCtx(() => [
          _createVNode(_component_MapWindow)
        ]),
        _: 1
      }),
      _createVNode(_component_FooterBar),
      _createElementVNode("div", {
        id: "overlay-main",
        class: _normalizeClass({
      'overlay': true,
      'overlay--show': _ctx.showModal
    })
      }, null, 2),
      (_ctx.showEventListModal)
        ? (_openBlock(), _createBlock(_component_EventsListModal, {
            key: 0,
            show: _ctx.showEventListModal
          }, null, 8, ["show"]))
        : _createCommentVNode("", true),
      (_ctx.showInfoModal)
        ? (_openBlock(), _createBlock(_component_InfoModal, {
            key: 1,
            show: _ctx.showInfoModal
          }, null, 8, ["show"]))
        : _createCommentVNode("", true),
      (_ctx.showStartModal && !_ctx.mobileView() && !_ctx.isPopupDisabled())
        ? (_openBlock(), _createBlock(_component_StartModal, {
            key: 2,
            show: _ctx.showStartModal
          }, null, 8, ["show"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CookiesButton),
      _createVNode(_component_notifications, {
        group: "app-notif",
        position: "top left",
        ignoreDuplicates: true
      })
    ]),
    _: 1
  }, 8, ["class"]))
}